import React, { useMemo } from "react";
import dayjs from "dayjs";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Area,
  ComposedChart,
} from "recharts";

const SubscriptionTrendChart = ({ data = [] }) => {
  const chartData = useMemo(() => {
    if (!Array.isArray(data)) return [];

    return data.map((d) => ({
      date: dayjs(d.date).format("DD MMM"),
      count: Number(d.count || 0),
    }));
  }, [data]);

  return (
    <div style={{ width: "100%", height: 320 }}>
      <ResponsiveContainer>
        <ComposedChart data={chartData}>
          {/* 🔥 gradient definition */}
          <defs>
            <linearGradient id="colorGradient" x1="0" y1="0" x2="1" y2="0">
              <stop offset="0%" stopColor="#6366f1" />
              <stop offset="50%" stopColor="#22c55e" />
              <stop offset="100%" stopColor="#06b6d4" />
            </linearGradient>

            {/* glow effect */}
            <filter id="glow">
              <feGaussianBlur stdDeviation="3.5" result="coloredBlur" />
              <feMerge>
                <feMergeNode in="coloredBlur" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
          </defs>

          {/* subtle grid */}
          <CartesianGrid
            strokeDasharray="3 6"
            stroke="#eef2f7"
            vertical={false}
          />

          <XAxis
            dataKey="date"
            tick={{ fill: "#6b7280", fontSize: 11 }}
            axisLine={false}
            tickLine={false}
          />

          <YAxis
            tick={{ fill: "#6b7280", fontSize: 11 }}
            axisLine={false}
            tickLine={false}
          />

          <Tooltip
            contentStyle={{
              borderRadius: 10,
              border: "1px solid #e5e7eb",
              boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
            }}
          />

          {/* 🔥 gradient area */}
          <Area
            type="monotone"
            dataKey="count"
            stroke="none"
            fill="url(#trendGradient)"
          />

          {/* 🔥 premium line */}
          <Line
            type="monotone"
            dataKey="count"
            stroke="url(#colorGradient)"
            strokeWidth={3}
            dot={{ r: 3 }}
            activeDot={{ r: 6 }}
            // activeDot={{
            //   r: 6,
            //   stroke: "#fff",
            //   strokeWidth: 2,
            //   fill: "#1677ff",
            //   filter: "url(#glow)",
            // }}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SubscriptionTrendChart;
